import { formatAmount } from "shared/topchef.utils";


const BudgetRenderer = ({ amount }: { amount: number }) => {

    const budget = amount === null ? 'non précisé' : formatAmount(amount);

    return (
      <span>{budget}</span>
    );

  };

  export default BudgetRenderer;
